/**
 * App global consts, managed in this file.
 * hewen.deng 2020/04/24
 */

 /** axios base */
const BASE = 'tms'

/** urls without base do not validated */
const PATTERNS_IGNORE = []

const LOGIN_PATH = 'http://sso.lexue365.com.cn/#/login'

const HOME_PATH = 'http://user.lexue365.com.cn/#/home'

export default {
  BASE,
  PATTERNS_IGNORE,
  LOGIN_PATH,
  HOME_PATH
}



// WEBPACK FOOTER //
// ./src/util/const-config.js